import StudentUserDataTable from './StudentUserDataTable'
import {useTranslation} from 'react-i18next'
import UnAuthorized from 'app/custom/UnAuthorized'
import {useAuth} from '../core/Auth'

const StudentUserList = () => {
  const {t} = useTranslation()
  const {hasPermission} = useAuth()

  return hasPermission('users-list') ? (
    <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
      <div className='card-header'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>{t('MENU.STUDENT_USERS')}</h3>
        </div>
      </div>
      <div className='card-body p-9'>
        <StudentUserDataTable
          headers={[
            {
              headerName: t('GLOBAL.USERNAME'),
              sort: 'name',
            },
            {
              headerName: t('GLOBAL.NAME'),
              sort: 'username',
            },
            {
              headerName: t('PROFILE.EMAIL'),
              sort: 'email',
            },
            {
              headerName: t('MENU.ROLES'),
              sort: 'user_roles',
            },
            {
              headerName: t('GLOBAL.ACTION'),
              sort: 'action',
            },
          ]}
          columns={['id', 'name', 'username', 'email', 'campus_id', 'user_roles', 'action']}
        />
      </div>
    </div>
  ) : (
    <UnAuthorized />
  )
}

export default StudentUserList
